import {forwardRef} from 'react';

import {Icon} from '../Icon';
import {Link, LinkProps} from '../Link';
import {ArrowBackOutlineSvg, ArrowRightOutline24Svg} from '../SvgIcons';

type Props = Omit<LinkProps, 'startIcon' | 'endIcon'> & {
  direction?: 'to-left' | 'to-right';
};

export const ArrowLink = forwardRef<HTMLAnchorElement, Props>((props, ref) => {
  const {direction = 'to-left', ...otherProps} = props;

  return (
    <Link
      startIcon={direction === 'to-left' && <Icon svg={ArrowBackOutlineSvg} />}
      endIcon={
        direction === 'to-right' && <Icon svg={ArrowRightOutline24Svg} />
      }
      ref={ref}
      prefetch={false}
      {...otherProps}
    />
  );
});

ArrowLink.displayName = 'ArrowLink';
